const LogoutPage = () => {
    localStorage.removeItem('accessToken');
    window.location.href = '/';
    return null;
}

export default LogoutPage;